import { Box, darken, lighten, styled } from '@mui/material';
import { m } from 'framer-motion';
export const overlay_variants = {
    hidden: {
        opacity: 0.5,
    },
    visible: {
        opacity: 1,
        transition: {
            duration: 0.25,
        },
    },
    exit: {
        opacity: 0,
    },
};
const panel_transition = {
    type: 'spring',
    damping: 30,
    stiffness: 300,
    duration: 0.25,
};
export const panel_variants = {
    hidden: {
        y: 1000,
        transition: panel_transition,
    },
    visible: {
        y: 0,
        transition: panel_transition,
    },
};
export const SwipableOverlay = styled(m.div)({
    background: 'rgba(21, 21, 21, 0.8)',
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 300,
    backdropFilter: 'blur(2px)',
    //VERY IMPORTANT FOR TOUCH INTERACTION
    touchAction: 'none',
});
export const Handle = styled(Box)(({ theme }) => ({
    width: 45,
    height: 5,
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'dark'
        ? lighten(theme.palette.background.default, 0.2)
        : darken(theme.palette.background.default, 0.2),
}));
